import MainComponentWrapper from "../Common/MainComponentWrapper";

const SearchSection = ({
  handleSearchChange,
  searchInput,
  isError,
  isLoading,
}) => {
  return (
    <MainComponentWrapper errorInfo={isError} Loading={isLoading}>
      <div className="event-my-earnings-field event-my-earnings-field--event">
        <label className="event-my-earnings-label" htmlFor="eventMyEarningsEventName">
          Search
        </label>
        <input
          id="eventMyEarningsEventName"
          className="event-my-earnings-input"
          type="search"
          name="eventName"
          placeholder="Enter Event Name"
          autoComplete="off"
          value={searchInput}
          onChange={handleSearchChange}
        />
      </div>
    </MainComponentWrapper>
  );
};

export default SearchSection;
